import { render } from "./DatasetCardLabelsPopper.vue?vue&type=template&id=3e73eafe&scoped=true"
import script from "./DatasetCardLabelsPopper.vue?vue&type=script&lang=js"
export * from "./DatasetCardLabelsPopper.vue?vue&type=script&lang=js"

import "./DatasetCardLabelsPopper.vue?vue&type=style&index=0&id=3e73eafe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e73eafe"]])

export default __exports__